var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.getKioskProfile.data().physicalKeyboard)?_c('div',{class:_vm.keyboardClass}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }